import Collapsable from './Collapsable'
export default Collapsable
